module.exports = __webpack_public_path__ + "static/media/7.13.7b176a22.png";